import { render, staticRenderFns } from "./TestA.vue?vue&type=template&id=5463d9a0&scoped=true&"
import script from "./TestA.vue?vue&type=script&lang=ts&"
export * from "./TestA.vue?vue&type=script&lang=ts&"
import style0 from "./TestA.vue?vue&type=style&index=0&id=5463d9a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463d9a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
